$('.dropdown-menu.keep-open').on('click', e => {
  e.stopPropagation();
});
